export const USERDATA_DELETE_RESET = 'USERDATA_DELETE_RESET'
export const USERDATA_DELETE_SET_ERROR = 'USERDATA_DELETE_SET_ERROR'
export const USERDATA_DELETE_SET_DELETED = 'USERDATA_DELETE_SET_DELETED'
export const USERDATA_DELETE_TOGGLE_LOADING = 'USERDATA_DELETE_TOGGLE_LOADING'
